<script lang="ts">
  import type { Token } from 'marked';
  import Block from './Block.svelte';
  import Inline from './Inline.svelte';

  interface Props {
    tokens: Token[];
  }
  let { tokens }: Props = $props();
</script>

{#each tokens as token, index (index)}
  {#if token.type === 'heading'}
    <svelte:element this={'h' + token.depth}>
      <Inline tokens={token.tokens} />
    </svelte:element>
  {:else if token.type === 'paragraph'}
    <p><Inline tokens={token.tokens} /></p>
  {:else if token.type === 'list'}
    {#if token.ordered}
      <ol>
        {#each token.items as li, index (index)}
          <li>
            <Block tokens={[li]} />
          </li>
        {/each}
      </ol>
    {:else}
      <ul>
        {#each token.items as li, index (index)}
          <li>
            <Block tokens={[li]} />
          </li>
        {/each}
      </ul>
    {/if}
  {:else if token.type === 'code'}
    <pre><code>{token.text}</code></pre>
  {:else if token.type === 'list_item'}
    <Block tokens={token.tokens!} />
  {:else if token.type === 'text'}
    <Inline tokens={token.tokens} />
  {/if}
{/each}

<style>
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ul,
  ol,
  pre,
  li,
  code {
    margin: 0;
    padding: 0;
  }

  ul,
  ol {
    list-style-position: outside;
    padding-left: 1em;
  }

  pre,
  code {
    font-family: monospace;
  }

  pre {
    white-space: pre-wrap;
  }
</style>
